module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var columns = widget.gridColumns() 
    ; __append("\n")
    ;  var actions = widget.gridActions() 
    ; __append("\n<div class=\"gridview table wh100\">\n\n	")
    ;  if (widget.showHeader) { 
    ; __append("\n	<div>\n		<div class=\"gridview__header\" name=\"gridview-header\"></div>\n	</div>\n	")
    ;  } 
    ; __append("\n\n	<div>\n		<div class=\"gridview__body\">\n			<div>\n				<div>\n					<table class=\"gridview__table\" name=\"gridview-body\">\n						<colgroup name=\"gridview-colgroup\"></colgroup>\n						<tbody name=\"list-items\">\n						</tbody>\n					</table>\n				</div>\n			</div>\n		</div>\n	</div>\n\n	")
    ;  if (widget.showFooter) { 
    ; __append("\n	<div>\n		<div class=\"gridview__footer split cell__middle\" name=\"gridview-footer\"></div>\n	</div>\n	")
    ;  } 
    ; __append("\n\n</div>\n")
  }
  return __output.join("");

}